import * as React from 'react'

import WarningIcon from '@wwt/shared/assets/icons/outline/warning.svg'

interface ErrorContentProps extends React.HTMLAttributes<HTMLDivElement> {
	ref?: React.RefObject<HTMLDivElement>
	title: string
	description: string | string[]
}

const ErrorContent = ({
	ref,
	title,
	description,
	...props
}: ErrorContentProps) => {
	const isArray = Array.isArray(description)

	return (
		<div
			ref={ref}
			{...props}
		>
			<div className="mb-4 flex size-12 items-center justify-center rounded-full border">
				<WarningIcon />
			</div>
			<h4 className="text-foreground mb-2 text-xl font-semibold">{title}</h4>
			{isArray ? (
				description.length > 1 ? (
					<ul className="ml-5 list-disc">
						{description.map(item => (
							<li key={item}>{item}</li>
						))}
					</ul>
				) : (
					<p>{description[0]}</p>
				)
			) : (
				<p>{description}</p>
			)}
		</div>
	)
}
ErrorContent.displayName = 'ErrorContent'

export { ErrorContent }
